import SwitchContainer from "../../../../../Components/Forms&Table/Forms/FormWidgets/Switch/SwitchContainer";

const Switch = () => {
  return <SwitchContainer />;
};

export default Switch;
